import { ModalErrorModel } from '@/core/domain/modal-error/models/modal-error.model';
import { createAction, props } from '@ngrx/store';

export const openModalError = createAction(
    '[MODAL ERROR] Open',
    props<{ data: ModalErrorModel }>(),
);

export const closeModalError = createAction('[MODAL ERROR] Close');
